<template>
    <div class="reseller-password-forgot">
        <div class="container">
            <div class="row justify-center">
                <div class="md:w-1/2 lg:w-5/12 w-full">
                    <div class="lg:px-20">
                        <div class="text-center">
                            <h1 class="h4 mb-8">{{ translations.forgot_title }}</h1>
                            <p class="mb-40">{{ translations.forgot_description }}</p>
                        </div>

                        <el-form class="mb-24" @submit="submit" :loading="loading" :success="success" :error="server_error" button-class="btn btn-green btn-lg btn-rounded w-full mt-8 font-bold" :submit-text="translations.forgot_button">
                            <el-input v-model="formData.email" rules="required|email" :label="translations.forgot_email" class="mb-16"></el-input>
                        </el-form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import hasForm from '@mixins/components/has-form'

export default {
    name: "Ui.ResellerPasswordForgot",

    mixins: [hasForm],

    props: {
        translations: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            formData: {
                email: '',
            }
        }
    },

    methods: {
        submit() {
            this.beforeSubmit();

            axios.post('/api/forgot-password', this.formData)
                .then(response => {
                    this.handleSuccess();
                })
                .catch(e => this.handleError(e));
        }
    }
}
</script>